import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeaderMobile from "./components/HeaderMobile";
import Scrolltop from "./components/Scrolltop";
import IndexRouters from "./router";
import Aside from "./components/Aside";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoginPage from "./pages/auth/login"; // tambahkan
import ProfileNotification from "./components/ProfileNotification";
import ChatWidget from "./components/ChatWidget";

function App() {
  const location = useLocation();
  const path = location.pathname;

  const generateTitle = (path) => {
    if (path === "/" || path === "/login") return "Login"; // kalau mau judul khusus login

    const parts = path.split("/").filter(Boolean);
    const title = parts
      .map((part) =>
        part.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
      )
      .join(" / ");

    return title;
  };

  const isLoginPage = path === "/login" || path === "/";
  const isPrintPage = path.startsWith("/print/");
  const title = generateTitle(path);

  // Initialize aside close button only (mobile togglers handled in HeaderMobile)
  useEffect(() => {
    if (!isLoginPage && !isPrintPage) {
      const timer = setTimeout(() => {
        // Initialize aside close button
        const closeBtn = document.getElementById("kt_aside_close_btn");
        if (closeBtn && !closeBtn.dataset.initialized) {
          closeBtn.dataset.initialized = "true";
          closeBtn.onclick = (e) => {
            e.preventDefault();
            document.body.classList.remove("kt-aside--on");
          };
        }

        // Try Metronic initialization if available
        if (window.KTLayout && typeof window.KTLayout.init === "function") {
          window.KTLayout.init();
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isLoginPage, isPrintPage]);

  // Kalau halaman login atau print, render simple layout (tanpa sidebar/header)
  if (isLoginPage || isPrintPage) {
    return (
      <div>
        <IndexRouters />
        <Scrolltop />
        <ChatWidget />
      </div>
    );
  }

  // Layout utama untuk semua selain /login
  return (
    <div>
      <ProfileNotification />
      <HeaderMobile />
      <div className="kt-grid kt-grid--hor kt-grid--root">
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
          <button className="kt-aside-close" id="kt_aside_close_btn">
            <i className="la la-close"></i>
          </button>
          <Aside />

          <div
            className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
            id="kt_wrapper"
          >
            <Header />
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
              <div className="kt-subheader kt-grid__item" id="kt_subheader">
                <div className="kt-subheader__main">
                  <h3 className="kt-subheader__title">{title}</h3>
                  <span className="kt-subheader__separator kt-subheader__separator--v" />
                </div>
              </div>
              <IndexRouters />
            </div>
            <Footer />
          </div>
        </div>
      </div>
      <Scrolltop />
      <ChatWidget />
    </div>
  );
}

export default App;

